import { useState } from 'react';
import { useEffectOnce } from 'react-use';
import { useCustomer, useUserIsLoggedIn } from '@app/user';
import useUpdateCustomer from '@app/hooks/useUpdateCustomer';
import { EXPERIMENTS } from '@app/config';
import { useExperiment } from '@app/experiments';

const useSetUserTimezone = () => {
  const shouldPersistTimezone = useExperiment(
    EXPERIMENTS.web_sell_persist_timezone,
  );

  const customer = useCustomer();
  const isLoggedIn = useUserIsLoggedIn();
  const [, setError] = useState('');
  const [, setLoading] = useState<boolean>(false);
  const { updateCustomer } = useUpdateCustomer({
    setError,
    setLoading,
  });

  useEffectOnce(() => {
    if (!isLoggedIn || !shouldPersistTimezone) {
      return;
    }

    const { id, Meta } = customer ?? {};

    //Perform timezone check for the user
    const currentUserTimezone = Meta?.timezone;
    const systemTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const updateCustomerTimezone = async () => {
      await updateCustomer(id, {
        Customer: { Meta: { timezone: systemTimezone } },
      });
    };

    if (
      !currentUserTimezone ||
      (!!currentUserTimezone &&
        !!systemTimezone &&
        currentUserTimezone !== systemTimezone)
    ) {
      updateCustomerTimezone();
    }
  });
};

export default useSetUserTimezone;
